import React from "react";
import { Skeleton as ChakraSkeleton } from "@chakra-ui/react";

const Skeleton: React.FC = () => (
  <>
    {[...new Array(5)].map((_, i) => (
      <ChakraSkeleton
        height="98px"
        key={i}
        startColor="gray.200"
        endColor="gray.200"
        width="70px"
        borderRadius="4px"
      />
    ))}
  </>
);

export default Skeleton;
